import React from 'react';

export interface IdeozLoadingProps {
  size?: 'sm' | 'md' | 'lg';
}

const IdeozLoading: React.FC<IdeozLoadingProps> = ({ size = 'md' }) => {
  // Size configurations
  const sizeConfig = {
    sm: { width: 35, height: 9, scale: 0.75 },
    md: { width: 47, height: 12, scale: 1 },
    lg: { width: 70, height: 18, scale: 1.5 },
  };

  const config = sizeConfig[size];

  return (
    <div className="flex items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={config.width}
        height={config.height}
        viewBox="0 0 47 12"
        fill="none"
        className="ideoz-loading"
        style={{ transform: `scale(${config.scale})` }}
      >
        {/* First dot (i) */}
        <ellipse
          cx="1.43361"
          cy="1.65236"
          rx="1.43361"
          ry="1.43361"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_0s_forwards]"
        />

        {/* Letter i stem */}
        <path
          d="M0.105469 4.44516C0.105469 4.10546 0.380852 3.83008 0.720554 3.83008H2.14853C2.48823 3.83008 2.76362 4.10546 2.76362 4.44516V11.3836C2.76362 11.7233 2.48823 11.9987 2.14853 11.9987H0.720554C0.380852 11.9987 0.105469 11.7233 0.105469 11.3836V4.44516Z"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.2s_forwards]"
        />

        {/* Letter d */}
        <path
          d="M9.74797 10.3836C9.74797 10.3575 9.72683 10.3364 9.70077 10.3364C9.6797 10.3364 9.66123 10.3504 9.6551 10.3705C9.58851 10.5898 9.48699 10.7991 9.35054 10.9984C9.20703 11.1971 9.0304 11.3736 8.82065 11.5281C8.62194 11.6715 8.39011 11.7819 8.12516 11.8591C7.87125 11.9474 7.6063 11.9915 7.33032 11.9915C6.22637 11.9915 5.39289 11.6053 4.82987 10.8329C4.26686 10.0495 3.98535 8.91848 3.98535 7.43988C3.98535 5.96129 4.26686 4.83579 4.82987 4.06338C5.39289 3.29098 6.22637 2.90478 7.33032 2.90478C7.89333 2.90478 8.39011 3.05926 8.82065 3.36822C9.25152 3.66969 9.52999 4.05521 9.65605 4.52477C9.66159 4.54537 9.68013 4.55993 9.70147 4.55993C9.72715 4.55993 9.74797 4.53911 9.74797 4.51343V0.307543C9.74797 0.137692 9.88566 0 10.0555 0H11.8912C12.061 0 12.1987 0.137692 12.1987 0.307543V11.4854C12.1987 11.6552 12.061 11.7929 11.8912 11.7929H10.0555C9.88566 11.7929 9.74797 11.6552 9.74797 11.4854V10.3836ZM8.14172 10.0054C8.60538 10.0054 8.98624 9.89502 9.28431 9.67433C9.59341 9.44261 9.74797 9.12813 9.74797 8.7309V6.16542C9.74797 5.76819 9.59341 5.45922 9.28431 5.23854C8.98624 5.00682 8.60538 4.89096 8.14172 4.89096C7.67806 4.89096 7.29168 5.05647 6.98257 5.3875C6.68451 5.7075 6.53547 6.14335 6.53547 6.69507V8.20125C6.53547 8.75297 6.68451 9.19434 6.98257 9.52537C7.29168 9.84536 7.67806 10.0054 8.14172 10.0054Z"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.4s_forwards]"
        />

        {/* Letter e */}
        <path
          d="M18.2239 12.0002C17.5071 12.0002 16.8679 11.8868 16.3064 11.6598C15.7449 11.4208 15.2671 11.0923 14.8728 10.6742C14.4905 10.2441 14.1978 9.72439 13.9947 9.11511C13.8036 8.50583 13.708 7.82486 13.708 7.07222C13.708 6.33152 13.8036 5.6625 13.9947 5.06517C14.1859 4.45588 14.4666 3.9362 14.837 3.50612C15.2193 3.07603 15.6852 2.7475 16.2347 2.52051C16.7843 2.28158 17.4115 2.16211 18.1164 2.16211C18.8929 2.16211 19.5559 2.29352 20.1055 2.55635C20.667 2.81918 21.121 3.17161 21.4674 3.61364C21.8258 4.05567 22.0827 4.56938 22.238 5.15477C22.4052 5.72821 22.4889 6.33152 22.4889 6.9647V7.44564C22.4889 7.61549 22.3512 7.75318 22.1813 7.75318H16.5931C16.514 7.75318 16.4498 7.81737 16.4498 7.89654C16.4498 8.51777 16.617 9.01356 16.9515 9.38391C17.2861 9.74231 17.8117 9.92151 18.5285 9.92151C19.0781 9.92151 19.5261 9.81399 19.8725 9.59895C20.1245 9.43383 20.3639 9.24659 20.5907 9.03722C20.7269 8.91145 20.9431 8.92045 21.0593 9.0649L22.0066 10.2426C22.0992 10.3578 22.0978 10.5236 21.9942 10.6291C21.6011 11.0299 21.1089 11.3495 20.5176 11.5881C19.8486 11.8629 19.084 12.0002 18.2239 12.0002ZM18.1701 4.1154C17.6325 4.1154 17.2084 4.2946 16.8978 4.653C16.5991 4.99946 16.4498 5.46538 16.4498 6.05077C16.4498 6.12995 16.514 6.19413 16.5931 6.19413H19.5858C19.6749 6.19413 19.7471 6.12192 19.7471 6.03285C19.7471 5.45941 19.6157 4.99946 19.3528 4.653C19.102 4.2946 18.7077 4.1154 18.1701 4.1154Z"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.6s_forwards]"
        />

        {/* Letter o */}
        <path
          d="M28.404 12.0002C27.711 12.0002 27.0898 11.8868 26.5403 11.6598C26.0027 11.4328 25.5427 11.1042 25.1604 10.6742C24.7901 10.2441 24.5033 9.72439 24.3002 9.11511C24.0972 8.50583 23.9956 7.82486 23.9956 7.07222C23.9956 6.31957 24.0972 5.63861 24.3002 5.02933C24.5033 4.42004 24.7901 3.90633 25.1604 3.4882C25.5427 3.05811 26.0027 2.72958 26.5403 2.50259C27.0898 2.2756 27.711 2.16211 28.404 2.16211C29.0969 2.16211 29.7121 2.2756 30.2497 2.50259C30.7993 2.72958 31.2592 3.05811 31.6296 3.4882C32.0119 3.90633 32.3046 4.42004 32.5077 5.02933C32.7107 5.63861 32.8123 6.31957 32.8123 7.07222C32.8123 7.82486 32.7107 8.50583 32.5077 9.11511C32.3046 9.72439 32.0119 10.2441 31.6296 10.6742C31.2592 11.1042 30.7993 11.4328 30.2497 11.6598C29.7121 11.8868 29.0969 12.0002 28.404 12.0002ZM28.404 9.90359C28.9296 9.90359 29.3358 9.74231 29.6225 9.41975C29.9092 9.09719 30.0526 8.63724 30.0526 8.0399V6.12245C30.0526 5.52512 29.9092 5.06517 29.6225 4.7426C29.3358 4.42004 28.9296 4.25876 28.404 4.25876C27.8783 4.25876 27.4721 4.42004 27.1854 4.7426C26.8987 5.06517 26.7553 5.52512 26.7553 6.12245V8.0399C26.7553 8.63724 26.8987 9.09719 27.1854 9.41975C27.4721 9.74231 27.8783 9.90359 28.404 9.90359Z"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.8s_forwards]"
        />

        {/* Letter z */}
        <path
          d="M34.4697 11.7811C34.3848 11.7811 34.3159 11.7123 34.3159 11.6273V9.74301C34.3159 9.70529 34.3298 9.66889 34.3549 9.64072L38.765 4.68991C38.8533 4.59078 38.7829 4.43386 38.6502 4.43386H34.631C34.546 4.43386 34.4772 4.36501 34.4772 4.28009V2.52682C34.4772 2.44189 34.546 2.37305 34.631 2.37305H41.9216C42.0065 2.37305 42.0753 2.44189 42.0753 2.52682V4.3932C42.0753 4.43093 42.0615 4.46734 42.0364 4.49551L37.6085 9.46421C37.5201 9.56334 37.5905 9.72029 37.7233 9.72029H42.047C42.1319 9.72029 42.2008 9.78914 42.2008 9.87406V11.6273C42.2008 11.7123 42.1319 11.7811 42.047 11.7811H34.4697Z"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_1s_forwards]"
        />

        {/* Last circle (blinking) */}
        <circle
          cx="44.7559"
          cy="10.5645"
          r="1.43361"
          fill="#344054"
          className="opacity-0 animate-[fadeIn_0.3s_ease-out_1.2s_forwards,blink_0.8s_infinite_1.5s]"
        />
      </svg>
    </div>
  );
};

export default IdeozLoading;
